import React, { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { formatError } from "@/lib/api";

export function Login() {
  const { login } = useAuth();
  const [form, setForm] = useState({ email: "", password: "" });
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);
  const nav = useNavigate();
  const [params] = useSearchParams();
  const redirect = params.get("redirect") || "/";

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true); setErr("");
    try {
      const u = await login(form.email, form.password);
      nav(u.role === "admin" ? "/admin" : redirect);
    } catch (ex) {
      setErr(formatError(ex));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-md mx-auto px-6 py-24" data-testid="login-page">
      <div className="overline text-[#B97A48] mb-3">Area clienti</div>
      <h1 className="font-serif text-5xl leading-tight">Accedi</h1>
      <p className="mt-4 text-[#5C5A56]">Bentornato. Inserisci le tue credenziali.</p>

      <form onSubmit={submit} className="mt-10 space-y-4">
        <input type="email" className="input-field" required placeholder="Email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} data-testid="login-email" />
        <input type="password" className="input-field" required placeholder="Password" value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} data-testid="login-password" />
        {err && <div className="p-3 bg-[#9E413B]/10 text-[#9E413B] text-sm border border-[#9E413B]/30" data-testid="login-error">{err}</div>}
        <button type="submit" disabled={loading} className="btn-primary w-full justify-center" data-testid="login-submit">
          {loading ? "Accesso…" : "Accedi"}
        </button>
      </form>
      <p className="mt-8 text-sm text-[#5C5A56]">
        Non hai un account? <Link to="/registrati" className="link-underline text-[#1C1B1A]" data-testid="register-link">Crea un account</Link>
      </p>
    </div>
  );
}

export function Register() {
  const { register } = useAuth();
  const [form, setForm] = useState({ name: "", email: "", password: "", phone: "" });
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true); setErr("");
    try {
      await register(form);
      nav("/");
    } catch (ex) {
      setErr(formatError(ex));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-md mx-auto px-6 py-24" data-testid="register-page">
      <div className="overline text-[#B97A48] mb-3">Registrazione</div>
      <h1 className="font-serif text-5xl leading-tight">Crea un account</h1>
      <p className="mt-4 text-[#5C5A56]">Unisciti all'atelier. Prenotazioni più veloci e storico ordini.</p>

      <form onSubmit={submit} className="mt-10 space-y-4">
        <input className="input-field" required placeholder="Nome e cognome" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} data-testid="reg-name" />
        <input type="email" className="input-field" required placeholder="Email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} data-testid="reg-email" />
        <input className="input-field" placeholder="Telefono (opzionale)" value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} data-testid="reg-phone" />
        <input type="password" className="input-field" required minLength={6} placeholder="Password (min 6 caratteri)" value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} data-testid="reg-password" />
        {err && <div className="p-3 bg-[#9E413B]/10 text-[#9E413B] text-sm border border-[#9E413B]/30" data-testid="reg-error">{err}</div>}
        <button type="submit" disabled={loading} className="btn-primary w-full justify-center" data-testid="reg-submit">
          {loading ? "Creazione…" : "Crea account"}
        </button>
      </form>
      <p className="mt-8 text-sm text-[#5C5A56]">
        Hai già un account? <Link to="/accedi" className="link-underline text-[#1C1B1A]">Accedi</Link>
      </p>
    </div>
  );
}
